import Resource from '@/services/resources/common';

export default class DocumentOfficialResource extends Resource {
  constructor(entrypoint = '/document_officials', alias = 'DocumentOfficial') {
    super(entrypoint, alias);
  }
}
